export default __webpack_public_path__ + "static/media/hostfullyLogo.558d4448.svg";